var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-swipe-cell',{attrs:{"on-close":_vm.onClose}},[_c('record-item',{attrs:{"recordData":_vm.recordData,"itemFunc":_vm.itemFunc}}),_c('template',{slot:"right"},[_c('div',{staticClass:"com-record-delete"},[_vm._v("删除")])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }